import React from "react";

export default function MintBlack() {
  return (
    <div
      to="/mint"
      className="col-md-6 d-flex flex-column justify-content-between text-white mint__left"
    >
      <div className="d-flex justify-content-between mint__left__top">
        {/* Top Left Small Text */}
        <h6 className="mt-2 col-4">THE HODLERZ</h6>

        {/* Gray Box */}
        <a
          href="https://opensea.io/collection/thehodlerz"
          target="_blank"
          rel="noreferrer"
          className="gray__box col-4 d-flex justify-content-center align-items-center"
        >
          <img src="/Images/grey.gif" alt="" />
        </a>

        {/* Top Right Small TExt */}
        <h6 className="mt-2 col-4 text-end">UP ONLY</h6>
      </div>

      {/* Big Texts */}
      <div className="big__texts">
        <h3 className="mt-5">
          WE BELIEVE IN OUR BAGS, <br /> WE NEVER SELL, LONG VISION <br /> STOCK
          TO FLOW IS OUR RELIGION, <br /> MICHAEL SAYLOR IS OUR GOD... <br />{" "}
          BUT THIS IS HARD TIME, SO DONT BE STINGY AND MINT SOME HODLERZ.
        </h3>
        <h1 className="my-5">
          ROADMAP? <br /> WE ARE CURRENTLY BROKE, BUT WE GUARANTEE 2.5% OF
          ROYALTIES TO THE HODLERZ COMMUNITY. AND YES...F**K YOU FUDDERS!
        </h1>
      </div>

      {/* Footer Small TExt */}
      <div className="footer d-flex align-items-center justify-content-between">
        <div className="col-8">
          <h6>THE HODLERZ © 2023 BY DAZE</h6>
        </div>
        <div className="col-4">
          {/* <h6 className="text-end mx-1">DEATH VISION LAB</h6> */}
        </div>
      </div>
    </div>
  );
}
